export const lessonType = Object.freeze({
	ONLINE: "Online",
	ONSITE: "Onsite",
});

export type TLessonType = (typeof lessonType)[keyof typeof lessonType];
